/** Отзыв игрока — подключение к стору и колбэкам. */
import type { FeedbackInput } from "./actions";
import type { WindowProps } from "../kit";
import { ApiError } from "@newfungame/contracts";
import { type FeedbackError, FeedbackView } from "./view";
import { registerWindow } from "../../../app";
import { actions } from "../actions";
import { useEffect, useState } from "preact/hooks";

declare module "../../../app/state/window-route" {
  interface WindowRoutes {
    feedback: object;
  }
}

/** На iOS клавиатура ложится поверх игры: окно поднимаем на её высоту. На Android вьюпорт сжимается сам, здесь 0. */
function useKeyboardLift(): void {
  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;
    const root = document.documentElement.style;
    const update = () => {
      const lift = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
      root.setProperty("--win-keyboard", `${Math.round(lift)}px`);
    };
    vv.addEventListener("resize", update);
    vv.addEventListener("scroll", update);
    return () => {
      vv.removeEventListener("resize", update);
      vv.removeEventListener("scroll", update);
      root.removeProperty("--win-keyboard");
    };
  }, []);
}

export function Feedback({ close }: WindowProps<"feedback">) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<FeedbackError | null>(null);
  const [done, setDone] = useState(false);
  useKeyboardLift();
  const send = (input: FeedbackInput): void => {
    setBusy(true);
    setError(null);
    actions()
      .sendFeedback(input)
      .then(() => setDone(true))
      .catch((e: unknown) => setError(e instanceof ApiError && e.code === "rate_limited" ? "limit" : "failed"))
      .finally(() => setBusy(false));
  };
  return <FeedbackView busy={busy} error={error} done={done} onSend={send} onClose={close} />;
}

export function register(): void {
  registerWindow("feedback", Feedback);
}
